export default "__VITE_ASSET__DWnpU5QS__"